import { createSupabaseClient } from '@dukanti/shared';
import { env } from '@dukanti/shared/env';

/** Module-level Supabase singleton for the admin app. Initialized once on
 *  first import and reused everywhere. Tests mock via
 *  `vi.mock('@/lib/supabase')`. The storage key is unique to admin so its
 *  session does not collide with the storefront when both apps run on the
 *  same origin in local dev. */
export const supabase = createSupabaseClient({
  url: env.VITE_SUPABASE_URL,
  anonKey: env.VITE_SUPABASE_ANON_KEY,
  storageKey: 'dukanti-admin-auth',
});
